import { useLayoutEffect, useSyncExternalStore } from 'react';
const BOOT_SKELETON_ID = 'rl-boot-skeleton';
let dismissed = false;
const listeners = new Set();
let skeletonObserver;
/** Fades out the fixed `#rl-boot-skeleton` overlay from `public/index.html`. */ export const dismissBootSkeleton = ()=>{
    if (dismissed) {
        return;
    }
    dismissed = true;
    const remove = window.__removeBootSkeleton;
    remove === null || remove === void 0 ? void 0 : remove();
};
export const useDismissBootSkeleton = (enabled = true)=>{
    useLayoutEffect(()=>{
        if (enabled) {
            dismissBootSkeleton();
        }
    }, [
        enabled
    ]);
};
const touchesSkeleton = (records)=>records.some((record)=>[
            ...record.addedNodes,
            ...record.removedNodes
        ].some((node)=>node instanceof Element && node.id === BOOT_SKELETON_ID));
const subscribeToBootSkeleton = (onStoreChange)=>{
    listeners.add(onStoreChange);
    if (!skeletonObserver && typeof MutationObserver !== 'undefined') {
        skeletonObserver = new MutationObserver((records)=>{
            if (touchesSkeleton(records)) {
                listeners.forEach((listener)=>listener());
            }
        });
        skeletonObserver.observe(document.body, {
            childList: true
        });
    }
    return ()=>{
        listeners.delete(onStoreChange);
        if (listeners.size === 0) {
            skeletonObserver === null || skeletonObserver === void 0 ? void 0 : skeletonObserver.disconnect();
            skeletonObserver = undefined;
        }
    };
};
/**
 * Tracks the overlay's real presence rather than the dismissal call:
 * `__removeBootSkeleton` fades for 200ms and only then detaches the node, so
 * dropping the layer at fade-start leaves the skeleton painting over the page
 * for the whole fade.
 */ const getIsBootSkeletonPresent = ()=>document.getElementById(BOOT_SKELETON_ID) !== null;
export const useIsBootSkeletonPresent = ()=>useSyncExternalStore(subscribeToBootSkeleton, getIsBootSkeletonPresent, ()=>false);
